<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem"
          />
          <p class="mt-2 mb-0">
            Cargando…
          </p>
        </div>
      </template>

      <b-row>
        <b-col md="5">
          <contract-values :data="data" />
        </b-col>

        <b-col
          md="7"
          class="float-right"
        >
          <contract-balance
            :key="componentKey"
            :idcontrato="data.idcontrato"
          />
        </b-col>
      </b-row>

      <div
        class="d-flex justify-content-end mt-1"
        style="gap: 0.5rem"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="flat-secondary"
          class="btn-icon"
          @click="searchAccountState()"
        >
          <feather-icon icon="RefreshCwIcon" />
        </b-button>
      </div>

      <b-form-group class="mt-1">
        <b-table
          :tbody-tr-class="rowClass"
          class="position-relative"
          :items="dataReport"
          responsive
          :fields="fieldscontratocuota"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
          hover
        >
          <template #cell()="dataRow">
            <span class="rowstyle">{{ dataRow.value }}</span>
          </template>

          <template #cell(id)="dataRow">
            <span class="rowstyle">{{ dataRow.index + 1 }}</span>
          </template>

          <template #cell(date)="dataRow">
            <span class="rowstyle">{{
              dataRow.item.date | dateFormat
            }}</span>
          </template>
        </b-table>
      </b-form-group>
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormGroup,
  BOverlay,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue"

import { avatarText } from "@core/utils/filter"
import Ripple from "vue-ripple-directive"
import ContractBalance from "./ContractBalance.vue"
import ContractValues from "./ContractValues.vue"

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BOverlay,
    BSpinner,
    ContractValues,
    ContractBalance,
  },
  directives: {
    Ripple,
  },
  filters: {
    dateFormat(string) {
      if (!string) return ""

      return string.split("-").reverse().join("/")
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      show: true,
      fieldscontratocuota: [
        {
          key: "id",
          label: "No.",
          sortable: false,
        },
        {
          key: "type",
          label: "Transaccion",
          sortable: false,
        },
        {
          key: "date",
          label: "Fecha",
          sortable: false,
        },
        {
          key: "detail",
          label: "Concepto",
          sortable: false,
        },
        {
          key: "debit",
          label: "Debito",
          sortable: false,
          class: "text-right",
        },
        {
          key: "credit",
          label: "Credito",
          sortable: false,
          class: "text-right",
        },
        {
          key: "balance",
          label: "Saldo",
          sortable: false,
          class: "text-right",
        },
      ],
      dataReport: [],
      componentKey: 0,
    }
  },
  created() {
    this.searchAccountState()
  },
  methods: {
    searchAccountState() {
      this.show = true
      this.$http
        .get("/contrato-estado-cuenta", {
          params: {
            idcontrato: this.data.idcontrato,
            idempresa: this.data.idempresa,
            idusuario: this.userData.id,
          },
        })
        .then((response) => {
          this.show = false
          this.dataReport = response.data.contratoscuota
        })
        .catch((error) => {
          this.show = false
          console.log(error)
        })
    },
    rowClass(item, type) {
      if (!item || type !== "row") {
        return undefined
      }

      switch (item.type) {
      case "Cuota":
        return "table-success"
      case "Recibo Ingreso":
        return "table-primary"
      default:
        return undefined
      }
    },
    reload() {
      this.searchAccountState()
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1
    },
  },
}
</script>

<style>
.rowstyle {
    font-size: 0.8125rem;
    color: var(--tm-text);
}
</style>
